import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ExpensesPage } from '@/features/cost/expenses-page';

const searchSchema = z.object({
  /** Open this expense (e.g. one just recorded from a scanned receipt). */
  expense: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/cost/expenses')({
  validateSearch: searchSchema,
  component: ExpensesRoute,
});

function ExpensesRoute() {
  const { projectId } = Route.useParams();
  const { expense } = Route.useSearch();
  return <ExpensesPage projectId={projectId} expenseId={expense} />;
}
